/**
 * Decision-feed rows for the Live chapter — the sentences the runtime
 * writers produce, so the tutorial narrates the day in the app's own words.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenEventRow } from '@trafficpulse/shared';

import { DEMO_RUN_DATE } from './demo-plan';

const at = (hhmmCph: string) => `${DEMO_RUN_DATE}T${hhmmCph}:00.000Z`;

const ev = (
  id: string,
  event: string,
  source: string,
  atIso: string,
  headline: string,
  reason: string | null,
  containerName: string | null = null,
): DropGenEventRow => ({
  id,
  event,
  source,
  at: atIso,
  headline,
  reason,
  containerId: containerName ? `demo-${containerName.toLowerCase().replace(/[^a-z]+/g, '-')}` : null,
  containerName,
  runDate: DEMO_RUN_DATE,
});

export const DEMO_EVENTS: DropGenEventRow[] = [
  ev('e1', 'day_generated', 'GENERATE', at('00:58'), 'Day generated — 42 drafts across 3 containers', null),
  ev('e2', 'creative_done', 'CREATIVE', at('01:04'), 'Creative fill done — 42 drafts got texts & senders', null),
  ev('e3', 'drop_sent', 'SEND', at('01:06'), 'WARM UP — drop sent on AU_ABDELH_CLICKERS · 500 SMS', null, 'WARM UP'),
  ev('e4', 'drop_pinned', 'OPERATOR', at('01:12'), 'WARM UP — 1 draft pinned by hand', 'hand-edited — the engine will not correct these rows (today only)', 'WARM UP'),
  ev('e5', 'slot_skipped', 'OPERATOR', at('01:15'), 'slot skipped for today', 'draft deleted — re-generates hold this slot until a Reset', 'CLEARANCE-CLICKS'),
  ev('e6', 'drop_sent', 'AUTOSEND', at('01:35'), 'WARM UP — drop auto-sent on AU_ABDELH_CLICKERS · 500 SMS', null, 'WARM UP'),
  ev('e7', 'verdict_evaluated', 'GENERATE', at('05:15'), 'Verdicts evaluated — 1 pass · 1 fail · 1 inconclusive · 0 pending', null),
  ev('e8', 'list_burned', 'GENERATE', at('05:16'), 'CLEARANCE-CLICKS — AU_ABDELH_CLICKERS burned: terrible', 'Delivered Rate 62% is < 85% — tomorrow starts on the next list', 'CLEARANCE-CLICKS'),
  ev('e9', 'group_stopped', 'GENERATE', at('05:16'), 'CLEARANCE-CLICKS — clickers stopped for today (19 drops)', 'the list failed its verdict and the container stops for the day', 'CLEARANCE-CLICKS'),
];
